import React, { useState } from 'react'
import { useAuth0 } from '../../Hooks/auth0'
import { Formik, Form } from 'formik'
import { Button, FormikInput, Card, Divider, Row, Col, Dialog, H1 } from '../../Elements'
import { useNavigate } from 'react-router-dom'
import { useToast } from '../../Hooks/toast'
import { LoginSchema } from '@mmg/validation'
import { primaryTheme } from '../../utils/helpers'

const cardStyle = {
    maxWidth: 500,
    margin: '0 auto',
    border: '3px double black',
    backgroundImage: `linear-gradient(180deg, white 0%, ${primaryTheme} 700%)`
}

const buttonStyle = {
    width: '100%',
    textAlign: 'center'
}

export default () => {
    const navigate = useNavigate()
    const { login, changePassword } = useAuth0()
    const [passwordResetIsOpen, setPasswordResetIsOpen] = useState(false)
    const { showSuccess, showError } = useToast()

    const onSubmit = async ({ email, password }, ...props) => {
        const result = login(email, password)

        result
            .catch(err => {
                showError(err.toString())
            })
            .then(res => {
                if (res) {
                    navigate(res)
                } else {
                    navigate('/')
                }
            })
    }

    const triggerPasswordResetFlow = async (email, formikSetFieldValue) => {
        await changePassword(email)
            .then((res) => {
                showSuccess('An email containing password reset instructions has been sent to the specified email address if it exists in the system.')
                formikSetFieldValue('email', email)
                formikSetFieldValue('password', '')
                setPasswordResetIsOpen(false)
            })
            .catch((err) => showError(err))
    }

    return (
        <Card style={cardStyle}>
            <Formik
                initialValues={{}}
                onSubmit={onSubmit}
                validationSchema={LoginSchema}
                render={({ values, errors, setFieldValue, ...props }) => {
                    return (
                        <Form>
                            <Dialog
                                title='Password Reset Request'
                                isOpen={passwordResetIsOpen}
                                onClose={() => setPasswordResetIsOpen(false)}
                            >
                                <Card style={{ margin: '20px' }}>
                                    <FormikInput
                                        name='reset_prompt_email'
                                        label='Email'
                                        placeholder='Email'
                                        type='email'
                                    />
                                </Card>

                                <Row style={{ margin: '0 20px' }}>
                                    <Col xs={6} style={{ paddingLeft: '0' }}>
                                        <Button large icon='undo' intent='danger' text='Cancel' onClick={() => setPasswordResetIsOpen(false)} style={buttonStyle} />
                                    </Col>
                                    <Col xs={6} style={{ paddingRight: '0' }}>
                                        <Button
                                            large
                                            icon='direction-right'
                                            intent='primary'
                                            text='Submit'
                                            onClick={() => triggerPasswordResetFlow(values.reset_prompt_email, setFieldValue)} style={buttonStyle}
                                            disabled={!values.reset_prompt_email || errors.reset_prompt_email}
                                        />
                                    </Col>
                                </Row>
                            </Dialog>

                            <H1 className='login-heading' >Welcome To Insite</H1>
                            <FormikInput
                                name='email'
                                label='Email'
                                placeholder='Email'
                                type='email'
                                dependentName='reset_prompt_email'
                                dependentValueCalculation={(newValue) => newValue}
                            />
                            <FormikInput
                                type='password'
                                name='password'
                                label='Password'
                                placeholder="Password"
                            />

                            <Divider />

                            <Row>
                                <Col xs={6}>
                                    <Button
                                        large
                                        style={buttonStyle}
                                        text='Password Reset'
                                        onClick={() => setPasswordResetIsOpen(true)}
                                    />
                                </Col>
                                <Col xs={6}>
                                    <Button
                                        large
                                        text='Login'
                                        type='submit'
                                        intent='primary'
                                        style={buttonStyle}
                                        disabled={!values.email || !values.password || errors.email}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    )
                }}
            />
        </Card>
    )
}